import { useParams } from "react-router-dom";
import NotificationEditor from "./NotificationEditor";

export default function NotificationEditPage() {
  const { id } = useParams();

  return <NotificationEditor mode="edit" notificationId={id} />;
}